import React, { Component } from "react";
import CanvasJSReact from "@canvasjs/react-charts";

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataPoints: [], // Store the chart data points here
    };
  }

  // Helper function to format the wallet address
  formatWalletAddress(walletAddress) {
    // Shorten the address to the first 6 and last 4 characters
    return `${walletAddress.slice(0, 3)}.....${walletAddress.slice(-3)}`;
  }

  // Helper function to extract numeric value from total string (e.g., "$50.00" -> 50.00)
  extractNumericValue(totalString) {
    // Remove dollar sign and any other non-numeric characters except decimal point
    const numericString = totalString.replace(/[^\d.]/g, "");
    return parseFloat(numericString) || 0;
  }

  getDisplayName(userLevel) {
    const name = userLevel.name?.trim();

    if (name && name.toLowerCase() !== "anonymous") {
      return name;
    }

    return this.formatWalletAddress(userLevel.address);
  }

  fetchData = async () => {
    try {
      // Fetch total_amount data from the user_levels API
      const levelsResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/user_levels`,
      );
      const levelsData = await levelsResponse.json();
      console.log("levelsData.......", levelsData);

      // Use a map to accumulate total for each wallet_address
      const holdersMap = new Map();

      // Aggregate total for each wallet_address from userLevels array
      levelsData.userLevels.forEach((userLevel) => {
        const walletAddress = userLevel.address;
        const totalAmount = this.extractNumericValue(userLevel.total);
        const label = this.getDisplayName(userLevel);

        if (holdersMap.has(walletAddress)) {
          const holder = holdersMap.get(walletAddress);
          // If the wallet address exists, add the total_amount
          holder.total_amount += totalAmount;
          if (label !== this.formatWalletAddress(walletAddress)) {
            holder.label = label;
          }
        } else {
          // If it's a new wallet address, add it to the map
          holdersMap.set(walletAddress, {
            label,
            total_amount: totalAmount,
          });
        }
      });

      // Convert the holdersMap to an array and map it to an array of objects
      const holders = Array.from(
        holdersMap,
        ([wallet_address, holder]) => {
          return {
            label: holder.label, // Prefer name, fallback to formatted wallet address
            y: holder.total_amount,
            wallet_address: wallet_address, // Include the wallet address
          };
        },
      );

      // Sort the holders by total_amount in descending order
      const sortedHolders = holders.sort((a, b) => b.y - a.y);

      // Limit to the top 20 holders
      const topHolders = sortedHolders.slice(0, 20); // Only take the top 20

      // Update the state with the top holders data
      this.setState({
        dataPoints: topHolders,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Fetch data when the component is mounted
  componentDidMount() {
    this.fetchData();
  }

  render() {
    const options = {
      backgroundColor: "black", // Dark background for the chart
      title: {
        text: "Top 20 Holders",
        fontColor: "#fff",
        padding: "70px 0px", // White title text
      },
      axisX: {
        labelFontColor: "#fff", // White X axis labels
        labelAngle: -45, // Rotate the X-axis labels for better fit
        labelMaxWidth: 100, // Maximum width of labels to avoid overflow
      },
      axisY: {
        labelFontColor: "#fff", // White Y axis labels
        title: "Total Amount ($)", // Add Y-axis title
        titleFontColor: "#fff", // White Y-axis title
      },
      data: [
        {
          type: "column", // Set to column chart
          dataPoints: this.state.dataPoints, // Use the state data points
          color: "#FFB000", // Yellow bar color
          borderColor: "#ffcc00", // Border color for the bars (light yellow)
          borderThickness: 2, // Thickness of the border around the bars
          cornerRadius: 32,
        },
      ],
      toolTip: {
        shared: true,
        content: function (e) {
          const dataPoint = e.entries[0].dataPoint;
          return `${dataPoint.label}: $${dataPoint.y.toFixed(2)}<br>Wallet Address: ${dataPoint.wallet_address}`;
        }, // Show label, value and wallet address on hover
      },
      legend: {
        fontColor: "#fff", // White legend text color
      },
    };

    return (
      <div style={styles.chartContainer}>
        <CanvasJSChart options={options} />
      </div>
    );
  }
}

const styles = {
  chartContainer: {
    padding: "30px 20px", // Adds padding around the chart
    boxShadow:
      "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
    borderRadius: "10px", // Rounded corners for the container
    backgroundColor: "black", // Same background color for the container and chart
    display: "inline-block", // Keeps the container from taking the full width
  },
};

export default App;
